import React, { useState } from 'react';
import Modal from 'react-modal';
import Image from '../components/images/Image';
import ImageLoading from '../components/images/ImageLoading';
import { get } from '../components/common/fetch';
import PageTitle from '../components/common/PageTitle';

export async function getStaticProps() {
  const MINUTES = 15;
  const revalidate = 60 * MINUTES;

  let gallery;
  try {
    gallery = await get('/gallery');
  } catch (e) {
    console.log(e);
  }

  const images = gallery?.map((image) => ({
    // original: `/uploads/gallery/${image}.jpg`,
    src: `/uploads/gallery/${image}.jpg`,
    thumbnail: `/uploads/gallery/${image}_tb.jpg`,
  }));

  return {
    props: {
      images: images || [],
    },
    revalidate: images ? revalidate : 1, // In seconds
  };
}

const GalleryPage = ({ images }: any) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  return (
    <section className="gallery">
      <PageTitle title="Gallery" />
      <div className="container">
        <h1>Gallery</h1>
        {images
          ? images.map((image, i) => (
              <Image
                key={i}
                openLightbox={() => {
                  setCurrentImage(i);
                  setLightboxOpen(true);
                }}
                image={image}
              />
            ))
          : [0, 1, 2, 3, 4, 5].map((key) => <ImageLoading key={key} />)}
        {images && !!images.length && (
          <Modal
            isOpen={lightboxOpen}
            onRequestClose={() => setLightboxOpen(false)}
            style={{
              overlay: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              },
              content: {
                border: 0,
                background: 'none',
                padding: 0,
                position: 'relative',
              },
            }}
            shouldCloseOnOverlayClick
          >
            <img src={images[currentImage]?.src} style={{ display: 'flex', maxWidth: '80%' }} />
          </Modal>
        )}
      </div>
    </section>
  );
};

export default GalleryPage;
